import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { accountInfoModel, getAccountInfoServiceResModel } from '../../models/serviceResponse.model';
import { AccountService } from '../../services/account.service';
//import { NavigationService } from '../../../navigation/services/navigation.service';
import { AppConfig } from 'src/app/config-service/app.config';
import { TranslateService } from '@ngx-translate/core';
import { first, last, map, switchMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { loadUserInformation } from '../../ngrx/account-actions';
import { selectAccount } from '../../ngrx/account-selectors';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';
import { AccountRouterManager } from '../../controller/router-handler';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {
  userName: string = '';
  accountInfo!: accountInfoModel;
  userProfileImageSrc: string = '';

  private accountRouter = new AccountRouterManager(this.route);

  constructor(
    private route: Router, 
    private translate: TranslateService, 
    private accountService: AccountService,
    private store:Store,
    @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
  ){
    
    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);

    if(
        AppConfig.settings.imageSource && 
        AppConfig.settings.imageSource.defaultProfileImage
    ){
      this.userProfileImageSrc = AppConfig.settings.imageSource.defaultProfileImage;
    }
  }
  
  ngOnInit(): void{
      this.store.pipe(
        select(selectAccount),
      ).subscribe((user:any) =>{
        if(user[0]){
            this.accountInfo = user[0];
            this.userName = this.accountInfo.userName    
        }
      }
    )
  }

  onClickProfile(){
    this.accountRouter.toProfile(this.accountInfo);
  }

}
